import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Popover,
  Typography,
} from "@mui/material";
import { makeStyles } from'@mui/styles';
import { CloseModal } from "styles/globalSVG";

const useStyles = makeStyles((theme) => ({
  textStyle: {
    textAlignLast: "center",
    width: "250px",
    margin: "0 auto",
    color: "rgba(0, 27, 17, 0.7)",
    fontSize: "16px",
  },

  acceptButton: {
    padding: "0 1rem",
    "&:hover": {
      backgroundColor: "#27AA83",
      color: "#fff",
    },
  },

  organizationButton: {
    padding: "0 1rem",
    "&:hover": {
      backgroundColor: "#27AA83",
      color: "#fff",
    },
  },

  cancelButton: {
    padding: "0 1rem",
    "&:hover": {
      backgroundColor: "#E4475B",
      color: "#fff",
    },
  },
  closeButton: {
    position: "absolute",
    right: "0",
  },

  popover: {
    pointerEvents: "none",
  },
  popOverPaper: {
    backgroundColor: "var(--accent-new-main)",
    margin: theme.spacing(1.2),
    padding: theme.spacing(1.2),
    color: "white",
  },
  dialogStyle: {
    zIndex: 13000,
  },
}));

const AskUser = (props) => {
  const { ask, setAsk, upgradeTeam, premiumPlan, organizationPlan } = props;

  const cancelClick = () => {
    setAsk(false);
  };

  const classes = useStyles();
  return (
    <>
      <Dialog
        open={ask}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialogStyle}
        role="alertdialog"
      >
        <div style={{ padding: "1rem" }}>
          <Button
            aria-label="Close upgrade plan dialog"
            className={classes.closeButton}
            onClick={cancelClick}
          >
            <CloseModal />
          </Button>
          <DialogTitle id="alert-dialog-title">
            {"Upgrading Team Plan"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to upgrade your team plan to{" "}
              {premiumPlan && (
                <span style={{ fontSize: "18px", color: "#6380F2" }}>
                  Premium
                </span>
              )}
              {organizationPlan && (
                <span style={{ fontSize: "18px", color: "#F28A4B" }}>
                  Organization
                </span>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className={classes.cancelButton}
              color="primary"
              onClick={cancelClick}
              aria-label="Cancel upgrade"
            >
              Cancel
            </Button>
            {premiumPlan && (
              <Button
                className={classes.acceptButton}
                color="primary"
                onClick={upgradeTeam}
                autoFocus
                aria-label="Upgrade to Premium"
              >
                <Typography>Yes</Typography>
              </Button>
            )}
            {organizationPlan && (
              <dispatchEvent>
                <Button
                  className={classes.acceptButton}
                  color="primary"
                  onClick={upgradeTeam}
                  autoFocus
                  aria-label="Upgrade to Organization"
                >
                  <Typography>Yes</Typography>
                </Button>
              </dispatchEvent>
            )}
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};

export default AskUser;
